// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file core/v1/user.proto (package core.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { ID, Timezone } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file core/v1/user.proto.
 */
export const file_core_v1_user: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_types]);

/**
 * User represents a user in the system
 *
 * @generated from message core.v1.User
 */
export type User = Message<"core.v1.User"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string idp_id = 2;
   */
  idpId: string;

  /**
   * @generated from field: string first_name = 3;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 4;
   */
  lastName: string;

  /**
   * @generated from field: string email = 5;
   */
  email: string;

  /**
   * @generated from field: string phone_number = 6;
   */
  phoneNumber: string;

  /**
   * @generated from field: types.Timezone timezone = 7;
   */
  timezone?: Timezone;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message core.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 0);

/**
 * @generated from message core.v1.CreateUserRequest
 */
export type CreateUserRequest = Message<"core.v1.CreateUserRequest"> & {
  /**
   * @generated from field: core.v1.CreateUserInput input = 1;
   */
  input?: CreateUserInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message core.v1.CreateUserRequest.
 * Use `create(CreateUserRequestSchema)` to create a new message.
 */
export const CreateUserRequestSchema: GenMessage<CreateUserRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 1);

/**
 * @generated from message core.v1.CreateUserInput
 */
export type CreateUserInput = Message<"core.v1.CreateUserInput"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string idp_id = 2;
   */
  idpId: string;

  /**
   * @generated from field: string first_name = 3;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 4;
   */
  lastName: string;

  /**
   * @generated from field: string email = 5;
   */
  email: string;

  /**
   * @generated from field: string phone_number = 6;
   */
  phoneNumber: string;

  /**
   * @generated from field: types.Timezone timezone = 7;
   */
  timezone?: Timezone;
};

/**
 * Describes the message core.v1.CreateUserInput.
 * Use `create(CreateUserInputSchema)` to create a new message.
 */
export const CreateUserInputSchema: GenMessage<CreateUserInput> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 2);

/**
 * @generated from message core.v1.UpdateUserRequest
 */
export type UpdateUserRequest = Message<"core.v1.UpdateUserRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string idp_id = 2;
   */
  idpId: string;

  /**
   * @generated from field: string first_name = 3;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 4;
   */
  lastName: string;

  /**
   * @generated from field: string email = 5;
   */
  email: string;

  /**
   * @generated from field: string phone_number = 6;
   */
  phoneNumber: string;

  /**
   * @generated from field: types.Timezone timezone = 7;
   */
  timezone?: Timezone;
};

/**
 * Describes the message core.v1.UpdateUserRequest.
 * Use `create(UpdateUserRequestSchema)` to create a new message.
 */
export const UpdateUserRequestSchema: GenMessage<UpdateUserRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 3);

/**
 * @generated from message core.v1.GetUserRequest
 */
export type GetUserRequest = Message<"core.v1.GetUserRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;
};

/**
 * Describes the message core.v1.GetUserRequest.
 * Use `create(GetUserRequestSchema)` to create a new message.
 */
export const GetUserRequestSchema: GenMessage<GetUserRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 4);

/**
 * @generated from message core.v1.GetUserByIdpIDRequest
 */
export type GetUserByIdpIDRequest = Message<"core.v1.GetUserByIdpIDRequest"> & {
  /**
   * @generated from field: string idp_id = 1;
   */
  idpId: string;
};

/**
 * Describes the message core.v1.GetUserByIdpIDRequest.
 * Use `create(GetUserByIdpIDRequestSchema)` to create a new message.
 */
export const GetUserByIdpIDRequestSchema: GenMessage<GetUserByIdpIDRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 5);

/**
 * @generated from message core.v1.GetUsersByIdpIDsRequest
 */
export type GetUsersByIdpIDsRequest = Message<"core.v1.GetUsersByIdpIDsRequest"> & {
  /**
   * @generated from field: repeated string idp_ids = 1;
   */
  idpIds: string[];
};

/**
 * Describes the message core.v1.GetUsersByIdpIDsRequest.
 * Use `create(GetUsersByIdpIDsRequestSchema)` to create a new message.
 */
export const GetUsersByIdpIDsRequestSchema: GenMessage<GetUsersByIdpIDsRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 6);

/**
 * @generated from message core.v1.GetUsersByIdpIDsResponse
 */
export type GetUsersByIdpIDsResponse = Message<"core.v1.GetUsersByIdpIDsResponse"> & {
  /**
   * @generated from field: repeated core.v1.User users = 1;
   */
  users: User[];
};

/**
 * Describes the message core.v1.GetUsersByIdpIDsResponse.
 * Use `create(GetUsersByIdpIDsResponseSchema)` to create a new message.
 */
export const GetUsersByIdpIDsResponseSchema: GenMessage<GetUsersByIdpIDsResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 7);

/**
 * @generated from message core.v1.GetUserByEmailRequest
 */
export type GetUserByEmailRequest = Message<"core.v1.GetUserByEmailRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message core.v1.GetUserByEmailRequest.
 * Use `create(GetUserByEmailRequestSchema)` to create a new message.
 */
export const GetUserByEmailRequestSchema: GenMessage<GetUserByEmailRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 8);

/**
 * @generated from message core.v1.AddUserToOrganizationRequest
 */
export type AddUserToOrganizationRequest = Message<"core.v1.AddUserToOrganizationRequest"> & {
  /**
   * @generated from field: types.ID user_id = 1;
   */
  userId?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message core.v1.AddUserToOrganizationRequest.
 * Use `create(AddUserToOrganizationRequestSchema)` to create a new message.
 */
export const AddUserToOrganizationRequestSchema: GenMessage<AddUserToOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 9);

/**
 * @generated from message core.v1.SetUserEmailVerifiedRequest
 */
export type SetUserEmailVerifiedRequest = Message<"core.v1.SetUserEmailVerifiedRequest"> & {
  /**
   * @generated from field: types.ID user_id = 1;
   */
  userId?: ID;
};

/**
 * Describes the message core.v1.SetUserEmailVerifiedRequest.
 * Use `create(SetUserEmailVerifiedRequestSchema)` to create a new message.
 */
export const SetUserEmailVerifiedRequestSchema: GenMessage<SetUserEmailVerifiedRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 10);

/**
 * @generated from message core.v1.SetUserPasswordRequest
 */
export type SetUserPasswordRequest = Message<"core.v1.SetUserPasswordRequest"> & {
  /**
   * @generated from field: types.ID user_id = 1;
   */
  userId?: ID;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message core.v1.SetUserPasswordRequest.
 * Use `create(SetUserPasswordRequestSchema)` to create a new message.
 */
export const SetUserPasswordRequestSchema: GenMessage<SetUserPasswordRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 11);

/**
 * @generated from message core.v1.GetUserResponse
 */
export type GetUserResponse = Message<"core.v1.GetUserResponse"> & {
  /**
   * @generated from field: core.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message core.v1.GetUserResponse.
 * Use `create(GetUserResponseSchema)` to create a new message.
 */
export const GetUserResponseSchema: GenMessage<GetUserResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 12);

/**
 * @generated from message core.v1.GetUserByIdpIDResponse
 */
export type GetUserByIdpIDResponse = Message<"core.v1.GetUserByIdpIDResponse"> & {
  /**
   * @generated from field: core.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message core.v1.GetUserByIdpIDResponse.
 * Use `create(GetUserByIdpIDResponseSchema)` to create a new message.
 */
export const GetUserByIdpIDResponseSchema: GenMessage<GetUserByIdpIDResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 13);

/**
 * @generated from message core.v1.GetUserByEmailResponse
 */
export type GetUserByEmailResponse = Message<"core.v1.GetUserByEmailResponse"> & {
  /**
   * @generated from field: core.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message core.v1.GetUserByEmailResponse.
 * Use `create(GetUserByEmailResponseSchema)` to create a new message.
 */
export const GetUserByEmailResponseSchema: GenMessage<GetUserByEmailResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 14);

/**
 * @generated from message core.v1.CreateUserResponse
 */
export type CreateUserResponse = Message<"core.v1.CreateUserResponse"> & {
  /**
   * @generated from field: core.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message core.v1.CreateUserResponse.
 * Use `create(CreateUserResponseSchema)` to create a new message.
 */
export const CreateUserResponseSchema: GenMessage<CreateUserResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 15);

/**
 * @generated from message core.v1.UpdateUserResponse
 */
export type UpdateUserResponse = Message<"core.v1.UpdateUserResponse"> & {
  /**
   * @generated from field: core.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message core.v1.UpdateUserResponse.
 * Use `create(UpdateUserResponseSchema)` to create a new message.
 */
export const UpdateUserResponseSchema: GenMessage<UpdateUserResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 16);

/**
 * @generated from message core.v1.ListUsersByOrganizationRequest
 */
export type ListUsersByOrganizationRequest = Message<"core.v1.ListUsersByOrganizationRequest"> & {
  /**
   * @generated from field: types.ID organization_id = 1;
   */
  organizationId?: ID;

  /**
   * @generated from field: string search_term = 2;
   */
  searchTerm: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset: number;
};

/**
 * Describes the message core.v1.ListUsersByOrganizationRequest.
 * Use `create(ListUsersByOrganizationRequestSchema)` to create a new message.
 */
export const ListUsersByOrganizationRequestSchema: GenMessage<ListUsersByOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 17);

/**
 * @generated from message core.v1.ListUsersByOrganizationResponse
 */
export type ListUsersByOrganizationResponse = Message<"core.v1.ListUsersByOrganizationResponse"> & {
  /**
   * @generated from field: repeated core.v1.User users = 1;
   */
  users: User[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message core.v1.ListUsersByOrganizationResponse.
 * Use `create(ListUsersByOrganizationResponseSchema)` to create a new message.
 */
export const ListUsersByOrganizationResponseSchema: GenMessage<ListUsersByOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 18);

/**
 * Request message for checking search permissions on users
 *
 * @generated from message core.v1.CheckUserSearchPermissionsRequest
 */
export type CheckUserSearchPermissionsRequest = Message<"core.v1.CheckUserSearchPermissionsRequest"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];
};

/**
 * Describes the message core.v1.CheckUserSearchPermissionsRequest.
 * Use `create(CheckUserSearchPermissionsRequestSchema)` to create a new message.
 */
export const CheckUserSearchPermissionsRequestSchema: GenMessage<CheckUserSearchPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 19);

/**
 * Response message for the CheckSearchPermissions RPC
 *
 * @generated from message core.v1.CheckUserSearchPermissionsResponse
 */
export type CheckUserSearchPermissionsResponse = Message<"core.v1.CheckUserSearchPermissionsResponse"> & {
  /**
   * @generated from field: repeated types.ID permitted_ids = 1;
   */
  permittedIds: ID[];
};

/**
 * Describes the message core.v1.CheckUserSearchPermissionsResponse.
 * Use `create(CheckUserSearchPermissionsResponseSchema)` to create a new message.
 */
export const CheckUserSearchPermissionsResponseSchema: GenMessage<CheckUserSearchPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_user, 20);

/**
 * User query service definition
 *
 * @generated from service core.v1.UserQueriesService
 */
export const UserQueriesService: GenService<{
  /**
   * @generated from rpc core.v1.UserQueriesService.GetUser
   */
  getUser: {
    methodKind: "unary";
    input: typeof GetUserRequestSchema;
    output: typeof GetUserResponseSchema;
  },
  /**
   * @generated from rpc core.v1.UserQueriesService.GetUserByIdpID
   */
  getUserByIdpID: {
    methodKind: "unary";
    input: typeof GetUserByIdpIDRequestSchema;
    output: typeof GetUserByIdpIDResponseSchema;
  },
  /**
   * @generated from rpc core.v1.UserQueriesService.GetUsersByIdpIDs
   */
  getUsersByIdpIDs: {
    methodKind: "unary";
    input: typeof GetUsersByIdpIDsRequestSchema;
    output: typeof GetUsersByIdpIDsResponseSchema;
  },
  /**
   * @generated from rpc core.v1.UserQueriesService.GetUserByEmail
   */
  getUserByEmail: {
    methodKind: "unary";
    input: typeof GetUserByEmailRequestSchema;
    output: typeof GetUserByEmailResponseSchema;
  },
  /**
   * @generated from rpc core.v1.UserQueriesService.ListUsersByOrganization
   */
  listUsersByOrganization: {
    methodKind: "unary";
    input: typeof ListUsersByOrganizationRequestSchema;
    output: typeof ListUsersByOrganizationResponseSchema;
  },
  /**
   * CheckSearchPermissions checks which of the provided user IDs the user has permission to access
   *
   * @generated from rpc core.v1.UserQueriesService.CheckSearchPermissions
   */
  checkSearchPermissions: {
    methodKind: "unary";
    input: typeof CheckUserSearchPermissionsRequestSchema;
    output: typeof CheckUserSearchPermissionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_core_v1_user, 0);

/**
 * User command service definition
 *
 * @generated from service core.v1.UserCommandsService
 */
export const UserCommandsService: GenService<{
  /**
   * @generated from rpc core.v1.UserCommandsService.CreateUser
   */
  createUser: {
    methodKind: "unary";
    input: typeof CreateUserRequestSchema;
    output: typeof CreateUserResponseSchema;
  },
  /**
   * @generated from rpc core.v1.UserCommandsService.UpdateUser
   */
  updateUser: {
    methodKind: "unary";
    input: typeof UpdateUserRequestSchema;
    output: typeof UpdateUserResponseSchema;
  },
  /**
   * @generated from rpc core.v1.UserCommandsService.AddUserToOrganization
   */
  addUserToOrganization: {
    methodKind: "unary";
    input: typeof AddUserToOrganizationRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc core.v1.UserCommandsService.SetUserEmailVerified
   */
  setUserEmailVerified: {
    methodKind: "unary";
    input: typeof SetUserEmailVerifiedRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc core.v1.UserCommandsService.SetUserPassword
   */
  setUserPassword: {
    methodKind: "unary";
    input: typeof SetUserPasswordRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_core_v1_user, 1);

